import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/buddy/cc-maintainer-fe/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
export function searchMeshes(_ref, payload) {
  var dispatch = _ref.dispatch;
  return dispatch('api', {
    url: 'meshes',
    params: _objectSpread({}, payload.params),
    wait: 'search-meshes',
    commitAfter: payload.commitAfter
  }, {
    root: true
  });
}
export function getMeshById(_ref2, payload) {
  var dispatch = _ref2.dispatch;
  return dispatch('api', {
    url: 'meshes/' + payload.id,
    params: _objectSpread({}, payload.params),
    commitAfter: payload.commitAfter
  }, {
    root: true
  });
}

/**
 * Select mesh
 *
 * @param commit
 * @param payload | Object
 * @returns {*}
 */
export function select(_ref3, payload) {
  var commit = _ref3.commit;
  return commit('SELECT', payload);
}

/**
 * Expand/Collapse Mesh
 *
 * @param commit
 * @param payload
 * @returns {*}
 */
export function onExpandMesh(_ref4, payload) {
  var commit = _ref4.commit;
  return commit('TOGGLE_EXPAND_MESH', payload);
}

/**
 * Expand/Collapse Cui
 *
 * @param commit
 * @param payload
 * @returns {*}
 */
export function onExpandCui(_ref5, payload) {
  var commit = _ref5.commit;
  return commit('TOGGLE_EXPAND_CUI', payload);
}

/**
 * Expand all Meshes and cuis.
 *
 * @param commit
 * @param childrenIds | Array of cuis for expand.
 */
export function expandAll(_ref6, childrenIds) {
  var commit = _ref6.commit;
  commit('EXPAND_ALL', childrenIds);
}

/**
 * Collapse all Meshes and cuis.
 *
 * @param commit
 */
export function collapseAll(_ref7) {
  var commit = _ref7.commit;
  commit('COLLAPSE_ALL');
}

/**
 * Create a record to pivot table between single MeSH and CUIs.
 *
 * @param dispatch
 * @param payload
 * @returns {*}
 */
export function createMeshCui(_ref8, payload) {
  var dispatch = _ref8.dispatch;
  return dispatch('api', {
    url: 'meshes/' + payload.mesh_code + '/cuis',
    method: 'post',
    data: {
      cuis: payload.cuis
    }
  }, {
    root: true
  });
}

/**
 * Delete a record to pivot table between single MeSH and CUIs.
 *
 * @param dispatch
 * @param payload
 * @returns {*}
 */
export function deleteMeshCui(_ref9, payload) {
  var dispatch = _ref9.dispatch;
  return dispatch('api', {
    url: 'meshes/cuis/delete',
    method: 'put',
    data: {
      ids: payload.ids
    }
  }, {
    root: true
  });
}